import titleGrandHsLandscape from '@assets/jackpot-link/grand-hs-l.png'
import titleGrandHsPortrait from '@assets/jackpot-link/grand-hs-p.png'
import titleGrandLandscape from '@assets/jackpot-link/grand-l.png'
import titleGrandPortrait from '@assets/jackpot-link/grand-p.png'
import panelGrandLandscape from '@assets/jackpot-link/grand-panel-l.png'
import panelGrandPortrait from '@assets/jackpot-link/grand-panel-p.png'
import stoneGrandFull from '@assets/jackpot-link/grand-stone.png'
import jackpotLinkLogoLandscape from '@assets/jackpot-link/jackpot-link-logo-l.png'
import jackpotLinkLogoPortrait from '@assets/jackpot-link/jackpot-link-logo-p.png'
import titleMajorHsLandscape from '@assets/jackpot-link/major-hs-l.png'
import titleMajorHsPortrait from '@assets/jackpot-link/major-hs-p.png'
import titleMajorLandscape from '@assets/jackpot-link/major-l.png'
import titleMajorPortrait from '@assets/jackpot-link/major-p.png'
import panelMajorLandscape from '@assets/jackpot-link/major-panel-l.png'
import panelMajorPortrait from '@assets/jackpot-link/major-panel-p.png'
import stoneMajorFull from '@assets/jackpot-link/major-stone.png'
import titleMiniLandscape from '@assets/jackpot-link/mini-l.png'
import titleMiniPortrait from '@assets/jackpot-link/mini-p.png'
import panelMiniLandscape from '@assets/jackpot-link/mini-panel-l.png'
import panelMiniPortrait from '@assets/jackpot-link/mini-panel-p.png'
import titleMinorLandscape from '@assets/jackpot-link/minor-l.png'
import titleMinorPortrait from '@assets/jackpot-link/minor-p.png'
import panelMinorLandscape from '@assets/jackpot-link/minor-panel-l.png'
import panelMinorPortrait from '@assets/jackpot-link/minor-panel-p.png'
import { JackpotLinkTypes, ViewportType } from 'game-ui-types'
import { JackpotLinkConfigType } from './types'

const stonePortraitY = 7
const stoneLandscapeY = 1.25
const stoneDesktopY = 3

const jackpotLinkConfigFactory = (type: JackpotLinkTypes = JackpotLinkTypes.GRAND): JackpotLinkConfigType => ({
    [ViewportType.MOBILE_PORTRAIT]: {
        jackpotStatistics: {
            // padding: { top: 10, sides: 8 },
            topRowMargin: { bottom: 4 },
            panelOuter: {
                width: type === JackpotLinkTypes.GRAND || type === JackpotLinkTypes.MAJOR ? 294 : 236,
                height: 87,
                marginBetween: 0,
            },
            amountBox: {
                width: type === JackpotLinkTypes.GRAND || type === JackpotLinkTypes.MAJOR ? 250 : 190,
                height: 65,
                fontSize: type === JackpotLinkTypes.GRAND || type === JackpotLinkTypes.MAJOR ? 46 : 42,
                leftSymbolPadding: -7,
                top: 9,
            },
            odometer: {
                winActiveTop: 6,
                fontSize: type === JackpotLinkTypes.GRAND || type === JackpotLinkTypes.MAJOR ? 52 : 46,
                fontColor: '#F6C000',
                stroke: {
                    width: 1,
                    color: '#FFEB1E',
                },
                fontColorGradient: 'linear-gradient(to top, #F6C000 10%, #FFFF54 50%, #F6C000 90%)',
                lineHeight: type === JackpotLinkTypes.GRAND || type === JackpotLinkTypes.MAJOR ? 70 : 70,
                fontWeight: '900',
                digitWidthPadding: 3,
                spaces: {
                    width: 8,
                },
            },
            winningUser: {
                top: 0,
                fontWeight: '400',
                fontSize: 14,
                fontColor: '#ffffff',
                lineHeight: 14,
            },
            currency: {
                paddingBottom: 0,
                right: 13,
                fontWeight: '700',
                fontSize: 18,
                lineHeight: 16,
                width: 12,
                fontColor: {
                    [JackpotLinkTypes.GRAND]: '#FB4747',
                    [JackpotLinkTypes.MAJOR]: '#4FC919',
                    [JackpotLinkTypes.MINOR]: '#299FD6',
                    [JackpotLinkTypes.MINI]: '#CD23FF',
                }[type],
            },
        },
        // jackpotLogo: {
        //     top: 23,
        //     width: 385,
        // },
        images: {
            logo: jackpotLinkLogoPortrait,
            panel: {
                [JackpotLinkTypes.GRAND]: panelGrandPortrait,
                [JackpotLinkTypes.MAJOR]: panelMajorPortrait,
                [JackpotLinkTypes.MINOR]: panelMinorPortrait,
                [JackpotLinkTypes.MINI]: panelMiniPortrait,
            }[type],
        },
        extended: {
            stone: {
                dimensions: 16,
                positions: {
                    [JackpotLinkTypes.GRAND]: [
                        { x: 18, y: stonePortraitY },
                        { x: 36, y: stonePortraitY },
                        { x: 53, y: stonePortraitY },
                    ],
                    [JackpotLinkTypes.MAJOR]: [{ x: 701, y: stonePortraitY }],
                    [JackpotLinkTypes.MINOR]: undefined,
                    [JackpotLinkTypes.MINI]: undefined,
                }[type],
                images: {
                    fullStone: {
                        [JackpotLinkTypes.GRAND]: stoneGrandFull,
                        [JackpotLinkTypes.MAJOR]: stoneMajorFull,
                        [JackpotLinkTypes.MINOR]: undefined,
                        [JackpotLinkTypes.MINI]: undefined,
                    }[type],
                },
            },
            titles: {
                height: 32,
                align: {
                    [JackpotLinkTypes.GRAND]: 'left',
                    [JackpotLinkTypes.MAJOR]: 'right',
                    [JackpotLinkTypes.MINOR]: 'left',
                    [JackpotLinkTypes.MINI]: 'right',
                }[type] as 'left' | 'right',
                images: {
                    default: {
                        [JackpotLinkTypes.GRAND]: titleGrandPortrait,
                        [JackpotLinkTypes.MAJOR]: titleMajorPortrait,
                        [JackpotLinkTypes.MINOR]: titleMinorPortrait,
                        [JackpotLinkTypes.MINI]: titleMiniPortrait,
                    }[type],
                    holdSpin: {
                        [JackpotLinkTypes.GRAND]: titleGrandHsPortrait,
                        [JackpotLinkTypes.MAJOR]: titleMajorHsPortrait,
                        [JackpotLinkTypes.MINOR]: undefined,
                        [JackpotLinkTypes.MINI]: undefined,
                    }[type],
                },
            },
        },
    },
    [ViewportType.MOBILE_LANDSCAPE]: {
        jackpotStatistics: {
            // padding: { top: 4, sides: 4 },
            panelOuter: {
                width: 238,
                height: 67,
                marginBetween: type === JackpotLinkTypes.MAJOR || type === JackpotLinkTypes.MINOR ? 3 : 0,
            },
            amountBox: {
                width: 205,
                height: 51,
                fontSize: 38,
                leftSymbolPadding: -5,
                top: 7,
            },
            odometer: {
                winActiveTop: 6,
                fontSize: 38,
                fontColor: '#F6C000',
                stroke: {
                    width: 1,
                    color: '#FFEB1E',
                },
                fontColorGradient: 'linear-gradient(to top, #F6C000 10%, #FFFF54 50%, #F6C000 90%)',
                lineHeight: 61,
                fontWeight: '900',
                digitWidthPadding: 3,
                spaces: {
                    width: 8,
                },
            },
            winningUser: {
                top: 2,
                fontWeight: '400',
                fontSize: 14,
                fontColor: '#ffffff',
                lineHeight: 14,
            },
            currency: {
                paddingBottom: 0,
                right: 10,
                fontWeight: '700',
                fontSize: 18,
                lineHeight: 16,
                width: 12,
                fontColor: {
                    [JackpotLinkTypes.GRAND]: '#FB4747',
                    [JackpotLinkTypes.MAJOR]: '#4FC919',
                    [JackpotLinkTypes.MINOR]: '#299FD6',
                    [JackpotLinkTypes.MINI]: '#CD23FF',
                }[type],
            },
        },
        // jackpotLogo: {
        //     top: 4,
        //     width: 359,
        // },
        images: {
            logo: jackpotLinkLogoLandscape,
            panel: {
                [JackpotLinkTypes.GRAND]: panelGrandLandscape,
                [JackpotLinkTypes.MAJOR]: panelMajorLandscape,
                [JackpotLinkTypes.MINOR]: panelMinorLandscape,
                [JackpotLinkTypes.MINI]: panelMiniLandscape,
            }[type],
        },
        extended: {
            stone: {
                dimensions: 14,
                positions: {
                    [JackpotLinkTypes.GRAND]: [
                        { x: 71, y: stoneLandscapeY },
                        { x: 86, y: stoneLandscapeY },
                        { x: 101, y: stoneLandscapeY },
                    ],
                    [JackpotLinkTypes.MAJOR]: [{ x: 324, y: stoneLandscapeY }],
                    [JackpotLinkTypes.MINOR]: undefined,
                    [JackpotLinkTypes.MINI]: undefined,
                }[type],
                images: {
                    fullStone: {
                        [JackpotLinkTypes.GRAND]: stoneGrandFull,
                        [JackpotLinkTypes.MAJOR]: stoneMajorFull,
                        [JackpotLinkTypes.MINOR]: undefined,
                        [JackpotLinkTypes.MINI]: undefined,
                    }[type],
                },
            },
            titles: {
                height: 28,
                align: 'center',
                images: {
                    default: {
                        [JackpotLinkTypes.GRAND]: titleGrandLandscape,
                        [JackpotLinkTypes.MAJOR]: titleMajorLandscape,
                        [JackpotLinkTypes.MINOR]: titleMinorLandscape,
                        [JackpotLinkTypes.MINI]: titleMiniLandscape,
                    }[type],
                    holdSpin: {
                        [JackpotLinkTypes.GRAND]: titleGrandHsLandscape,
                        [JackpotLinkTypes.MAJOR]: titleMajorHsLandscape,
                        [JackpotLinkTypes.MINOR]: undefined,
                        [JackpotLinkTypes.MINI]: undefined,
                    }[type],
                },
            },
        },
    },
    [ViewportType.DESKTOP]: {
        jackpotStatistics: {
            // padding: { top: 6, sides: 10 },
            panelOuter: {
                width: 320,
                height: 90,
                marginBetween: type === JackpotLinkTypes.MAJOR || type === JackpotLinkTypes.MINOR ? 10 : 0,
            },
            amountBox: {
                width: 270,
                height: 70,
                fontSize: 48,
                leftSymbolPadding: -8,
                top: 9,
            },
            odometer: {
                winActiveTop: 7,
                fontSize: 48,
                fontColor: '#F6C000',
                stroke: {
                    width: 1,
                    color: '#FFEB1E',
                },
                fontColorGradient: 'linear-gradient(to top, #F6C000 10%, #FFFF54 50%, #F6C000 90%)',
                filter: 'drop-shadow(0px 0px 4px #000000)',
                lineHeight: 80,
                fontWeight: '900',
                digitWidthPadding: 3,
                spaces: {
                    width: 8,
                },
            },
            winningUser: {
                top: 9,
                fontWeight: '400',
                fontSize: 14,
                fontColor: '#ffffff',
                lineHeight: 14,
            },
            currency: {
                paddingBottom: 0,
                right: 13,
                fontWeight: '700',
                fontSize: 24,
                lineHeight: 20,
                width: 17,
                fontColor: {
                    [JackpotLinkTypes.GRAND]: '#FB4747',
                    [JackpotLinkTypes.MAJOR]: '#4FC919',
                    [JackpotLinkTypes.MINOR]: '#299FD6',
                    [JackpotLinkTypes.MINI]: '#CD23FF',
                }[type],
            },
        },
        // jackpotLogo: {
        //     top: 6,
        //     width: 479,
        // },
        images: {
            logo: jackpotLinkLogoLandscape,
            panel: {
                [JackpotLinkTypes.GRAND]: panelGrandLandscape,
                [JackpotLinkTypes.MAJOR]: panelMajorLandscape,
                [JackpotLinkTypes.MINOR]: panelMinorLandscape,
                [JackpotLinkTypes.MINI]: panelMiniLandscape,
            }[type],
        },
        extended: {
            stone: {
                dimensions: 19,
                positions: {
                    [JackpotLinkTypes.GRAND]: [
                        { x: 100, y: stoneDesktopY },
                        { x: 120, y: stoneDesktopY },
                        { x: 140, y: stoneDesktopY },
                    ],
                    [JackpotLinkTypes.MAJOR]: [{ x: 445, y: stoneDesktopY }],
                    [JackpotLinkTypes.MINOR]: undefined,
                    [JackpotLinkTypes.MINI]: undefined,
                }[type],
                images: {
                    fullStone: {
                        [JackpotLinkTypes.GRAND]: stoneGrandFull,
                        [JackpotLinkTypes.MAJOR]: stoneMajorFull,
                        [JackpotLinkTypes.MINOR]: undefined,
                        [JackpotLinkTypes.MINI]: undefined,
                    }[type],
                },
            },
            titles: {
                height: 38,
                align: 'center',
                images: {
                    default: {
                        [JackpotLinkTypes.GRAND]: titleGrandLandscape,
                        [JackpotLinkTypes.MAJOR]: titleMajorLandscape,
                        [JackpotLinkTypes.MINOR]: titleMinorLandscape,
                        [JackpotLinkTypes.MINI]: titleMiniLandscape,
                    }[type],
                    holdSpin: {
                        [JackpotLinkTypes.GRAND]: titleGrandHsLandscape,
                        [JackpotLinkTypes.MAJOR]: titleMajorHsLandscape,
                        [JackpotLinkTypes.MINOR]: undefined,
                        [JackpotLinkTypes.MINI]: undefined,
                    }[type],
                },
            },
        },
    },
})

export const jackpotLinkConfig = {
    [JackpotLinkTypes.GRAND]: jackpotLinkConfigFactory(JackpotLinkTypes.GRAND),
    [JackpotLinkTypes.MAJOR]: jackpotLinkConfigFactory(JackpotLinkTypes.MAJOR),
    [JackpotLinkTypes.MINOR]: jackpotLinkConfigFactory(JackpotLinkTypes.MINOR),
    [JackpotLinkTypes.MINI]: jackpotLinkConfigFactory(JackpotLinkTypes.MINI),
}

export const defaultJackpotLinkConfig = jackpotLinkConfig[JackpotLinkTypes.GRAND]
